import React, { Component } from 'react';
import parse from 'html-react-parser';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import GridContainer from '../../../@jumbo/components/GridContainer';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { fade, Modal, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';

import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
//import Calendar from './index';
import Box from '@material-ui/core/Box';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import TextField from '@material-ui/core/TextField';
import { Alert, AlertTitle } from '@material-ui/lab';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const useStyles = theme => ({
  boxTop: {
    paddingTop: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  myButton: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
});

const DialogTitle = withStyles(useStyles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
}))(MuiDialogActions);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class AddCC extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    this.handleClose = this.handleClose.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.setRepeatPassword = this.setRepeatPassword.bind(this);
    // this.handleClick = this.handleClick.bind(this);
    this.state = {
      data: {},
      rows: [],
      ccHolderName: '',
      ccNumber: '',
      ccExpireMonth: '',
      ccExpireYear: '',
      ccType: '',
      ccCVV: '',
      password: '',
      repeatPassword: '',
      step: 3,
      viewAlert: false,
      alertMsg: '',
    };
    this.ccNumber = React.createRef();
    this.ccHolderName = React.createRef();
    this.ccExpireMonth = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.ccExpireYear = React.createRef();
    this.ccCVV = React.createRef();
  }
  handleClickOpen() {
    //  setOpen(true);
  }
  handleChange(name, value, value2) {
    this.setState({ [name]: value }, () => {});
  }
  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleClose() {
    this.props.setState({ viewAddCCVisible: false });
    //  setOpen(false);
  }
  setPassword(x) {
    this.setState({ password: x });
  }
  setRepeatPassword(x) {
    this.setState({ repeatPassword: x });
  }

  handleAdd() {
    const token = localStorage.getItem('token');
    const senddata = {
      Action: 'addCC',
      token: token,
      Version: 1,
      Data: {
        ReservationId: this.props.resId,
        ccHolderName: this.state.ccHolderName,
        ccType: this.state.ccType,
        ccNumber: this.state.ccNumber,
        ccExpireMonth: this.state.ccExpireMonth,
        ccExpireYear: this.state.ccExpireYear,
        ccCVV: this.state.ccCVV,
      },
    };
    //    console.log('pms');

    var pmsUrl = this.props.auth.authUser.pmsUrl;
    //      console.log(pmsUrl);
    if (pmsUrl == '') return;
    var mode = this.props.auth.authUser.clouduser;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      this.props.setState({ viewAddCCVisible: false });
      this.props.doRefresh();
      this.setState({
        ccHolderName: '',
        ccNumber: '',
        ccType: '',
        ccExpireMonth: '',
        ccExpireYear: '',
      });
    });

    //  setOpen(false);
  }

  render() {
    const { classes } = this.props;
    var mode = this.props.auth.authUser.clouduser;
    var currentYear = new Date().getFullYear();
    var years = [];
    for (let i = currentYear; i < currentYear + 10; i++) years.push(i);

    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.handleClose}
          anchorEl={this.props.anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}>
          <Box sx={style}>
            <GridContainer spacing={10}>
              <Grid item xs={12} sm={6} xl={6}>
                <TextField
                  error={this.state.ccHolderName != null && this.state.ccHolderName.length < 2}
                  helperText={
                    this.state.ccHolderName != null && this.state.ccHolderName.length < 2 ? (
                      <IntlMessages id="_CC_CARD_HOLDER_NAME_EMPTY" />
                    ) : (
                      ''
                    )
                  }
                  id="priceModel"
                  name="priceModel"
                  label=<IntlMessages id="_CREDIT_CARD_HOLDER_NAME" />
                  size="small"
                  inputProps={{ className: classes.wbpInput }}
                  variant="filled"
                  margin="small"
                  fullWidth
                  inputRef={el => (this.ccHolderName = el)}
                  value={this.state.ccHolderName}
                  onChange={event => this.handleChange('ccHolderName', event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6} xl={6}>
                <TextField
                  error={this.state.ccNumber != null && this.state.ccNumber.length < 12}
                  helperText={
                    this.state.ccNumber != null && this.state.ccNumber.length < 12 ? (
                      <IntlMessages id="_CC_CARD_INVALID_FORMAT" />
                    ) : (
                      ''
                    )
                  }
                  id="priceModel"
                  name="priceModel"
                  inputProps={{ className: classes.wbpInput }}
                  label=<IntlMessages id="_CREDIT_CARD_NUMBER" />
                  size="small"
                  margin="small"
                  fullWidth
                  variant="filled"
                  inputRef={el => (this.ccNumber = el)}
                  value={this.state.ccNumber}
                  onChange={event => this.handleChange('ccNumber', event.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6} xl={6}>
                <TextField
                  id="priceModel"
                  name="priceModel"
                  label=<IntlMessages id="_CREDIT_CARD_TYPE" />
                  size="small"
                  margin="small"
                  fullWidth
                  select
                  inputProps={{ className: classes.wbpInput }}
                  value={this.state.ccType}
                  variant="filled"
                  onChange={event => this.handleChange('ccType', event.target.value)}>
                  <MenuItem value="Visa">Visa</MenuItem>
                  <MenuItem value="Mastercard">Mastercard</MenuItem>
                  <MenuItem value="Maestro">Maestro</MenuItem>
                  <MenuItem value="Diners">Diners</MenuItem>
                  <MenuItem value="American Express">American Express</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} sm={2} xl={2}>
                <TextField
                  id="priceModel"
                  name="priceModel"
                  label=<IntlMessages id="_MONTH" />
                  size="small"
                  margin="small"
                  fullWidth
                  variant="filled"
                  select
                  inputProps={{ className: classes.wbpInput }}
                  value={this.state.ccExpireMonth}
                  onChange={event => this.handleChange('ccExpireMonth', event.target.value)}>
                  <MenuItem value="1">01</MenuItem>
                  <MenuItem value="2">02</MenuItem>
                  <MenuItem value="3">03</MenuItem>
                  <MenuItem value="4">04</MenuItem>
                  <MenuItem value="5">05</MenuItem>
                  <MenuItem value="6">06</MenuItem>
                  <MenuItem value="7">07</MenuItem>
                  <MenuItem value="8">08</MenuItem>
                  <MenuItem value="9">09</MenuItem>
                  <MenuItem value="10">10</MenuItem>
                  <MenuItem value="11">11</MenuItem>
                  <MenuItem value="12">12</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={6} sm={2} xl={2}>
                <TextField
                  id="priceModel"
                  name="priceModel"
                  label=<IntlMessages id="_YEAR" />
                  size="small"
                  variant="filled"
                  margin="small"
                  inputProps={{ className: classes.wbpInput }}
                  fullWidth
                  select
                  value={this.state.ccExpireYear}
                  onChange={event => this.handleChange('ccExpireYear', event.target.value)}>
                  {years.map(i => (
                    <MenuItem value={i}>{i}</MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={2} xl={2}>
                <TextField
                  id="priceModel"
                  name="priceModel"
                  label=<IntlMessages id="_CVV_CODE" />
                  size="small"
                  variant="filled"
                  margin="small"
                  inputProps={{ className: classes.wbpInput }}
                  fullWidth
                  value={this.state.ccCVV}
                  inputRef={el => (this.ccCVV = el)}
                  onChange={event => this.handleChange('ccCVV', event.target.value)}
                />
              </Grid>
            </GridContainer>
            <Button variant="contained" color="primary" className={classes.myButton} onClick={() => this.handleClose()}>
              <IntlMessages id="viewCC.close" />
            </Button>
            <Button variant="contained" color="primary" className={classes.myButton} onClick={() => this.handleAdd()}>
              <IntlMessages id="viewCC.addCC" />
            </Button>
          </Box>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(AddCC));
